import { getLocalizedOpenMarketplaceLink, getRedirectConfig } from '../config/productConfig';

export function redirectIfSkuMatches(sku: string | undefined, locale: string, level?: string) {
    if (!sku) {
        return;
    }
    const redirectUrl = getRedirectConfig(locale, sku, level);
    if (!redirectUrl) {
        window.location.replace(getLocalizedOpenMarketplaceLink(locale));
        return;
    }

    window.location.replace(redirectUrl);
}
